
class ClubResult{
    defaultOptions() {
        return {
        	'$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onFilterChange = this.onFilterChange.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/ClubResult","error");
        }

        this.$form = $('.competition-result-form',this.$container);
        this.$filterDiscipline = $('select[name="discipline"]',this.$form);
        this.$filterShowAll = $('input[name="showAll"]',this.$form);

        this.currentOffset = 0;

        this.initialize();
    }


    initialize(){
    	var self = this;

		this.$filterDiscipline.on('change',this.onFilterChange);
		this.$filterShowAll.on('change',this.onFilterChange);
    }

    onFilterChange(event){
    	let $filter = $(event.target);

		this.$form.trigger('submit');
    }

}

module.exports = ClubResult;